import VirtualTable from "../ui/VirtualTable";
import { useState, useEffect } from "react";
import { pubCall } from "../utils/PubSub";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { bm_date } from "../utils/Utils";

export default function ImportReports(props) {
    const { controller = "", callback = () => { }, route = "" } = props;
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({ sort: "" });
    const row_key = "report_num";
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("auto");

    const getBookmanagerReports = () => {
        pubCall("report.getBookmanagerReports", {sort: filters.sort}, (_s, _r) => {
            if (_s) {
                setData(_r);
            }
        })
    }

    useEffect(() => {
        getBookmanagerReports();
    }, [filters]);


    useEffect(() => {
        if(data?.length > 0){
            setSelected(data[0])
        } else {
            setSelected({})
        }
    }, [data])

    const column = [
        {
            key: "rptclerk", colSort: { current: filters.sort, callback: (e) => { setFilters({ ...filters, "sort": "rptclerk" }); } }, align: "center", title: <>CL</>, width: 80
        },
        {
            key: "rptupdated", colSort: { current: filters.sort, callback: (e) => { setFilters({ ...filters, "sort": "rptupdated" }); } }, align: "left", title: <>Updated</>, width: 180, render: (e) => bm_date(e, "MMMDD-YY")
        },
        {
            key: "detail", colSort: { current: (filters.sort === "report_name") ? "detail" : "", callback: (e) => { setFilters({ ...filters, "sort": "report_name" }); } }, align: "left", title: <>Report Name</>, width: 1000
        },
        {
            key: "report_num", align: "left", title: <>Rpt</>, width: 100
        },
    ]

    const next = (_rows = 1) => {

        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");
        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    }

    const nav = [
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
        { key: KBD.ENTER, action: () => callback(selected?.report_num) },
        { key: KBD.ESCAPE, action: () => { callback() } }
    ];

    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ENTER, KBD.ESCAPE]);
        return cleanup;
    }, [selected, data]);

    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                route={route}
                width={700}
                columns={column}
                data={data}
                next={next}
                prev={prev}
                onRowClick={(item, event, index) => { setSelected(item) }}
                onRowDoubleClick={(item) => { callback(item.report_num) }}
                align={align}
                row_key={row_key}
                current={selected}
            />
        </>
    )

}